import {
  updateLastLoginDate,  
  getAuthenticatedUserRoles,
} from '../api';
import { getTokenForUser } from '../utils/helpers';

const updateLastLoginDateRequested = () => ({
  type: 'UPDATE_LAST_LOGIN_DATE_REQUESTED',
});

const updateLastLoginDateSuccess = (lastLoginDate, previousLoginDate) => ({
  type: 'UPDATE_LAST_LOGIN_DATE_SUCCESS',
  payload: {
    lastLoginDate: lastLoginDate,
    previousLoginDate: previousLoginDate,
  },
});

const updateLastLoginDateFailure = error => ({
  type: 'UPDATE_LAST_LOGIN_DATE_FAILURE',
  payload: {
    error: error,
  },
});

const fetchAuthenticatedUserRolesStarted = email => ({
  type: 'FETCH_AUTHENTICATED_USER_ROLES_STARTED',
  email: email,
});

const fetchAuthenticatedUserRolesSuccess = userRoles => ({
  type: 'FETCH_AUTHENTICATED_USER_ROLES_SUCCESS',
  userRoles: userRoles,
});

const fetchAuthenticatedUserRolesFailure = error => ({
  type: 'FETCH_AUTHENTICATED_USER_ROLES_FAILURE',
  error: error,
});

const actionCreators = {
  getUserRoles: () => (dispatch, getState) => {
    const user = getState().oidc.user;
    
    if (getTokenForUser(user) != null) {
      dispatch(fetchAuthenticatedUserRolesStarted());
      getAuthenticatedUserRoles(user)
        .then(response => {
          dispatch(fetchAuthenticatedUserRolesSuccess(response.data));
        })
        .catch(err => {
          dispatch(fetchAuthenticatedUserRolesFailure(err));
        });
    }
  },

  updateLastLoginDate: user => dispatch => {
    dispatch(updateLastLoginDateRequested);
    
    if (getTokenForUser(user) != null) {  
      updateLastLoginDate(user)
        .then(response => {
          dispatch(
            updateLastLoginDateSuccess(
              response.data.lastLoginDate,
              response.data.previousLoginDate
            )
          );          
        })
        .catch(err => {
          dispatch(updateLastLoginDateFailure(err));
        });
    } else {
      dispatch(updateLastLoginDateFailure('User is not authenticated!'));
    }
  },
};

export default actionCreators;
